import featureTypes from './feature-types';
import shareholderTypes from './shareholder-types';

export default {
    [shareholderTypes.INSTITUTION]: featureTypes.INSTITUTION_OVERVIEW,
    [shareholderTypes.INSIDER]: featureTypes.INSIDER_OVERVIEW,
    [shareholderTypes.REGISTERED]: featureTypes.REGISTERED_OVERVIEW,
    [shareholderTypes.FUND]: featureTypes.FUND_OVERVIEW
};
